// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Belt_Option = require("rescript/lib/js/belt_Option.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.res.js");
var MM_cmp_user_stmt = require("./MM_cmp_user_stmt.res.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.res.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var Checkbox = require("@mui/material/Checkbox").default;

function getProofStatus(stmt) {
  if (stmt.isHyp) {
    return "Ready";
  } else {
    return stmt.proofStatus;
  }
}

function selectAllFlag(flags) {
  return flags.map(function (param) {
              return true;
            });
}

function unselectAllFlags(flags) {
  return flags.map(function (param) {
              return false;
            });
}

function invertFlags(flags) {
  return flags.map(function (v) {
              return !v;
            });
}

function updateFlags(st, update) {
  return {
          flags: update(st.flags)
        };
}

function MM_cmp_root_stmts(props) {
  var onClose = props.onClose;
  var flags = props.flags;
  var proofStatusesAreAvailable = props.proofStatusesAreAvailable;
  var rootStmtsRendered = props.rootStmtsRendered;
  var stmtToProve = props.stmtToProve;
  var match = React.useState(function () {
        return {
                flags: flags
              };
      });
  var setState = match[1];
  var state = match[0];
  var actSelectAllStmts = function () {
    setState(function (__x) {
          return updateFlags(__x, selectAllFlag);
        });
  };
  var actUnselectAllStmts = function () {
    setState(function (__x) {
          return updateFlags(__x, unselectAllFlags);
        });
  };
  var actInvertStmts = function () {
    setState(function (__x) {
          return updateFlags(__x, invertFlags);
        });
  };
  var actSelectProvedStmts = function () {
    setState(function (__x) {
          return updateFlags(__x, (function (__x) {
                        return __x.map(function (param, i) {
                                    return Belt_Option.getWithDefault(Belt_Option.map(getProofStatus(rootStmtsRendered[i]), (function (status) {
                                                      return status === "Ready";
                                                    })), false);
                                  });
                      }));
        });
  };
  var rndButtons = function () {
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        onClose(state.flags);
                      }),
                    variant: "outlined",
                    children: "Close"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        actUnselectAllStmts();
                      }),
                    children: "None"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        actSelectAllStmts();
                      }),
                    children: "All"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        actInvertStmts();
                      }),
                    children: "Inverse"
                  }), proofStatusesAreAvailable ? React.createElement(Button, {
                      onClick: (function (param) {
                          actSelectProvedStmts();
                        }),
                      children: "Proved"
                    }) : null);
  };
  var rndStmts = function () {
    var paddingTop = "10px";
    return React.createElement("table", undefined, React.createElement("tbody", undefined, state.flags.map(function (flag, i) {
                        var stmt = rootStmtsRendered[i];
                        return React.createElement("tr", {
                                    key: String(i),
                                    style: {
                                      verticalAlign: "top"
                                    }
                                  }, React.createElement("td", undefined, React.createElement(Checkbox, {
                                            checked: flag,
                                            onChange: (function (param) {
                                                setState(function (__x) {
                                                      return updateFlags(__x, (function (__x) {
                                                                    return __x.map(function (v, i$1) {
                                                                                if (i$1 === i) {
                                                                                  return !v;
                                                                                } else {
                                                                                  return v;
                                                                                }
                                                                              });
                                                                  }));
                                                    });
                                              })
                                          })), React.createElement("td", {
                                        style: {
                                          paddingTop: paddingTop
                                        }
                                      }, proofStatusesAreAvailable ? MM_cmp_user_stmt.rndProofStatus(getProofStatus(stmt), false, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined) : null), React.createElement("td", {
                                        style: {
                                          paddingTop: paddingTop
                                        }
                                      }, stmt.label + ": "), React.createElement("td", {
                                        style: {
                                          paddingTop: paddingTop
                                        }
                                      }, stmt.exprReElem));
                      })));
  };
  return React.createElement(Paper, {
              style: {
                padding: "10px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 1,
                        children: Caml_option.some(null)
                      }, stmtToProve, React.createElement("span", {
                            style: {
                              fontWeight: "bold"
                            }
                          }, props.title), rndButtons(), rndStmts(), rndButtons(), stmtToProve))
            });
}

var make = MM_cmp_root_stmts;

exports.make = make;
/* react Not a pure module */
